



























































import { Component, Vue } from 'vue-property-decorator'
import CustomDraggable from '@/components/CustomDraggable/index.vue'

@Component({
  name: 'StaticNetwork',
  components: {CustomDraggable}
})
export default class extends Vue {
    private group = 'mission'
    private list1 = [
      { name: 'RCE', version: '5.5.6' },
      { name: 'Nagios', version: '1.0.1' },
      { name: 'Ubuntu', version: '1.0.2' },
      { name: 'Icebox', version: '1.0.0' },
      { name: 'Ident Evil Backdoored VM', version: '1.0.0' },
      { name: 'Exploit Bleed', version: '1.0.0' }
    ]
    private list2 = [
      { name: 'ESA Linux', version: '1.0.0' },
      { name: 'Windows', version: '1.0.0' }
    ]
    private labList = [
      { name: 'Reception', version: '10.50.7.0/24'},
      { name: 'Doctors', version: '10.50.1.0/24'},
      { name: 'Medicine', version: '10.50.6.0/24'},
      { name: 'Electronic Medical Record', version: '10.50.3.0/24'},
      { name: 'Accounts Department', version: '10.50.4.0/24'},
      { name: 'Database - Patients', version: '10.50.13.0/24'},
      { name: 'IT Department', version: '10.50.2.0/24'}
    ]
}
